<div fxLayout="row wrap" fxLayoutAlign="space-between" class="border-bottom">
	<h3 class="arc-h3 margin-20" matDialogTitle>Contact Information: {{ data.caseNumber || 'N/A' }}</h3>
	<div class="col-sm-2 text-right">
		<app-close-mat-dialog (closeDialog)="dialogRef.close()"></app-close-mat-dialog>
	</div>
</div>

<mat-dialog-content>
	<mat-card appearance="outlined" class="border-bottom">
		<mat-spinner *ngIf="!loaded" diameter="70" id="spinner"></mat-spinner>
		<div *ngIf="loaded" fxLayout="row wrap" fxLayoutAlign="space-between center" class="margin-left-20">
			<label fxFlex="35"><strong>Assigned to</strong></label>
			<label fxFlex="65">
				{{ name || 'N/A' }} &nbsp;&nbsp;
				<mat-icon
					*ngIf="name"
					matRipple
					color="primary"
					inline
					class="more"
					appDebounceClick
					(debounceClick)="copyToClipboard(name)"
					matTooltip="Assigned to"
					appAnnounceTooltip="Assigned to"
				>
					content_copy
				</mat-icon>
			</label>

			<label fxFlex="35"><strong>Phone Number</strong></label>
			<label fxFlex="65">
				{{ phone || 'N/A' }} &nbsp;&nbsp;
				<mat-icon
					*ngIf="phone"
					matRipple
					color="primary"
					inline
					class="more"
					appDebounceClick
					(debounceClick)="copyToClipboard(phone)"
					matTooltip="Phone number"
					appAnnounceTooltip="Phone number"
				>
					content_copy
				</mat-icon>
			</label>

			<label fxFlex="35"><strong>Email Address</strong></label>
			<label fxFlex="65">
				{{ user?.contactInformation?.emailAddress || 'N/A' }} &nbsp;&nbsp;
				<mat-icon
					*ngIf="user?.contactInformation?.emailAddress"
					matRipple
					color="primary"
					inline
					class="more"
					appDebounceClick
					(debounceClick)="copyToClipboard(user?.contactInformation?.emailAddress)"
					matTooltip="Email address"
					appAnnounceTooltip="Email address"
				>
					content_copy
				</mat-icon>
			</label>
		</div>
	</mat-card>
</mat-dialog-content>

<mat-dialog-actions class="margin-10 padding-0">
	<div class="input-full-width pull-text-right">
		<button mat-flat-button color="primary" mat-dialog-close>CLOSE</button>
	</div>
</mat-dialog-actions>
